module.exports = __webpack_public_path__ + "img/verification-red.c6df5c6d.png";